module.exports = __webpack_public_path__ + "static/media/sidebar-2.e9df62a4.jpg";